import { Component, OnInit } from '@angular/core';
import { DateService } from '../services/date.service';
import { ActionsService } from '../services/actions.service';
import { GeneralService } from '../services/general.service';
import * as globalUrls from '../services/globalVariables';

declare var $: any;
@Component({
  selector: 'app-generate-facture',
  templateUrl: './generate-facture.component.html',
  styleUrls: ['./generate-facture.component.scss'],
})
export class GenerateFactureComponent implements OnInit {
  constructor(
    public actionsService: ActionsService,
    public generalService: GeneralService,
    public dateService: DateService
  ) {}
  date_Debut;
  date_Fin;
  showTree = false;
  //listeAction ;
  listeActionD;
  lastDayOfMonth;
  du;
  au;
  listeCollaborateur;
  dataTree;
  listeClient;
  ngOnInit() {
    this.date_Debut = new Date();
    this.date_Fin = new Date();
    this.date_Debut.setDate(-15);
    this.date_Fin.setDate(this.date_Fin.getDate() + 15);
    this.setListeCollaborateur();
    this.setListeClient();
  }
  async afficher() {
    this.showTree = true;
    //this.listeAction = await this.setListeAction();
    this.listeActionD = await this.generalService
      .rechercheTable(
        globalUrls.urlListeActionDjointureTiers +
          this.dateService.setFormatDateRechercheServer(this.date_Debut) +
          ',' +
          this.dateService.setFormatDateRechercheServer(this.date_Fin)
      )
      .toPromise();
    this.listeActionD.forEach((avtactionD) => {
      this.formaterTimeAvtActionD(avtactionD);
    });
    this.setDataTree();
    this.initTree();
    this.showTree = true;
  }
  formaterTimeAvtActionD(avtActionD) {
    avtActionD.avtActionD_heureDebAM = this.dateService.setFormaTime2(
      avtActionD.avtActionD_heureDebAM
    );
    avtActionD.avtActionD_heureFinAM = this.dateService.setFormaTime2(
      avtActionD.avtActionD_heureFinAM
    );
    avtActionD.avtActionD_heureDebPM = this.dateService.setFormaTime2(
      avtActionD.avtActionD_heureDebPM
    );
    avtActionD.avtActionD_heureFinPM = this.dateService.setFormaTime2(
      avtActionD.avtActionD_heureFinPM
    );
  }
  // getListeActionCode()
  // {
  //   var listeCodeAction = "";
  //   this.listeAction.forEach(action =>
  //   {
  //     listeCodeAction+=action.avtAction_Code+";";
  //   });
  //   return listeCodeAction;
  // }
  setDataTree() {
    this.dataTree = [];
    var i = 0;
    var j = 0;
    var k = 0;
    this.listeClient.forEach((client) => {
      i++;

      var listeAction = [];
      listeAction = this.listeActionD.filter((actionD) => {
        return actionD.Tiers_code == client.Tiers_code;
      });
      if (listeAction != undefined && listeAction.length > 0) {
        this.dataTree.push({
          id: client.Tiers_code + i.toString(),
          parent: '#',
          text:
            client.Tiers_NomPublic +
            ' Nbr.H: ' +
            this.actionsService.getNbrHeure(listeAction),
          a_attr: { myId: client.Tiers_code, actionD: false },
          icon: '../../assets/perso.png',
        });

        var listeAction_Code = this.generalService.distinct(
          this.listeActionD,
          'avtAction_Code'
        );

        listeAction_Code.forEach((actionCode) => {
          var action = listeAction.find((a) => {
            return a.avtAction_Code == actionCode;
          });
          j++;
          if (action != undefined) {
            this.dataTree.push({
              id: action.avtAction_Code + (j + i + 1000).toString(),
              parent: client.Tiers_code + i.toString(),
              text:
                action.avtAction_Intitule +
                ' Du ' +
                action.avtAction_dateDeb.substring(0, 10) +
                ' Au ' +
                action.avtAction_dateFin.substring(0, 10),
              a_attr: { myId: action.avtAction_Code, actionD: false },
              icon: '../../assets/action.png',
            });
            if (this.listeActionD.length > 0) {
              var listeCollaborateur = this.actionsService.getReferent(
                action.avtAction_Code,
                this.listeActionD,
                this.listeCollaborateur
              );
              listeCollaborateur.forEach((coll) => {
                k++;
                this.dataTree.push({
                  id:
                    coll.Perso_Matricule.toString() +
                    (k + j + i + 2000).toString(),
                  parent: action.avtAction_Code + (j + i + 1000).toString(),
                  text: coll.Perso_Nom,
                  a_attr: { myId: coll.Perso_Matricule, actionD: false },
                  icon: '../../assets/perso.png',
                });
                var listeActionD = this.listeActionD.filter((actionD) => {
                  return (
                    actionD.Perso_Matricule == coll.Perso_Matricule &&
                    action.avtAction_Code == actionD.avtAction_Code
                  );
                });
                listeActionD.forEach((actionD) => {
                  var time = ' ' + actionD.avtActionD_date.substring(0, 10);
                  if (actionD.avtActionD_heureDebAM != '')
                    time +=
                      ' AM: ' +
                      actionD.avtActionD_heureDebAM +
                      ' -> ' +
                      actionD.avtActionD_heureFinAM;
                  if (actionD.avtActionD_heureDebPM != '')
                    time +=
                      ' PM:  ' +
                      actionD.avtActionD_heureDebPM +
                      ' -> ' +
                      actionD.avtActionD_heureFinPM;
                  if (
                    actionD.avtActionD_remarque != '' &&
                    actionD.avtActionD_remarque != null
                  )
                    time += ' Remarque :' + actionD.avtActionD_remarque;
                  if (
                    actionD.avtActionD_suivi != '' &&
                    actionD.avtActionD_suivi != null
                  )
                    time += ' Suivi :' + actionD.avtActionD_suivi;

                  this.dataTree.push({
                    id: actionD.avtActionD_Code,
                    parent:
                      coll.Perso_Matricule.toString() +
                      (k + j + i + 2000).toString(),
                    text: actionD.avtActionD_Info + time,
                    a_attr: { myId: actionD.avtActionD_Code, actionD: true },
                    icon: '../../assets/calendar.png',
                  });
                });
              });
            }
          }
        });
      }
    });
  }
  // async setListeAction()
  // {
  //   this.du = this.dateService.setFormatDateRechercheServer(new Date(this.date_Debut));
  //   this.au = this.dateService.setFormatDateRechercheServer(new Date(this.date_Fin));
  //   //************************* */
  //   return await this.generalService.rechercheTable(this.generalService.url + "avtActionListDDF2" +this.du+","+this.au).toPromise();
  // }
  setListeCollaborateur() {
    this.generalService
      .rechercheTable(globalUrls.urlSelectPerso)
      .subscribe((coll) => {
        this.listeCollaborateur = coll.filter((c) => {
          return c.Perso_TypePerso != '2' && c.Perso_TypePerso != '10';
        });
      });
  }
  setListeClient() {
    this.generalService
      .rechercheTable(globalUrls.urlSelectClient)
      .subscribe((client) => {
        this.listeClient = client.filter((cli) => {
          return cli.Tiers_Type != '2';
        });
      });
  }
  initTree() {
    $('#treeFacture').jstree({
      plugins: ['checkbox'],
    });
    $('#treeFacture').jstree(true).settings.core.data = this.dataTree;
    $('#treeFacture').jstree(true).refresh();
  }
  generer() {
    //"avtActionD_Code":5688
    var jsonActionD = { avtactionD: [] };
    var MyTree = $('#treeFacture')
      .jstree(true)
      .get_checked($('#treeFacture').jstree(true)._model.data, true);
    var lsteActionDId = [];
    lsteActionDId = MyTree.filter((node) => {
      return node.a_attr.actionD == true;
    }).map((actionDId) => actionDId.a_attr.myId);
    if (lsteActionDId.length > 0) {
      lsteActionDId.forEach((code) => {
        jsonActionD.avtactionD.push({ avtActionD_Code: code });
      });
    }
    this.generalService.enregisterDoc(jsonActionD).subscribe(
      (data) => {
        console.log('enregistré:', data);
      },
      (err) => {
        if (err.error instanceof Error) {
          console.log(' erreur lors de l’enregistrement:', err.error.message);
        } else {
          console.log(`serveur ${err.status}, message: ${err.error}`);
        }
      }
    );
  }
}
